/** Gợi ý câu hỏi thống kê tổng quát — label ngắn, prompt đủ ý để gửi LLM */
export interface ChatSuggestionItem {
  label: string;
  prompt: string;
}

export const CHAT_SUGGESTION_PROMPTS: ChatSuggestionItem[] = [
  {
    label: "Doanh thu tháng này",
    prompt:
      "Tổng hợp doanh thu toàn nhà máy trong tháng này: tổng phải thu, đã thu, chưa thu và số hoá đơn.",
  },
  {
    label: "Theo từng khu vực",
    prompt:
      "Thống kê doanh thu và chỉ tiêu chính theo từng khu vực thu phí trong tháng này.",
  },
  {
    label: "So kỳ trước",
    prompt:
      "So sánh nhanh doanh thu hoặc số hoá đơn toàn hệ thống giữa tháng này và tháng trước.",
  },
  {
    label: "Hoá đơn đã / chưa thu",
    prompt:
      "Tổng quan tình trạng thu tiền hoá đơn toàn nhà máy trong tháng này (đã thu vs chưa thu).",
  },
  {
    label: "Lượng nước theo khu",
    prompt:
      "Thống kê tổng lượng nước tiêu thụ theo khu vực trong tháng này (tổng quan).",
  },
  {
    label: "Khách & hoá đơn",
    prompt:
      "Thống kê tổng số khách hàng đang hoạt động và số hoá đơn phát hành trong tháng này (mức tổng quát).",
  },
  {
    label: "Khu doanh thu cao",
    prompt:
      "Khu vực thu phí nào có doanh thu cao nhất trong tháng trước? Cho biết số liệu tóm tắt.",
  },
];
